import { Course } from '@components/courses/course-card'

const TRIAL_SLUG = 'math-trial-class'
const CURRICULUM_PDF_BASE =
  'https://codingal.s3.ap-south-1.amazonaws.com/web/pdfs/curriculum/math/math-curriculum-grade-'
const curriculumPdfFor = (grade: number) => `${CURRICULUM_PDF_BASE}${grade}.pdf`

export const MATH_COURSES: Course[] = [
  {
    id: 1,
    title: 'Build your course',
    description:
      "A learning plan designed entirely around your child's school syllabus, current level, and academic goals. Whether they need to catch up, get ahead, or prepare for specific exams, every class is shaped to fit.",
    thumbnailLandscape: '/images/courses/math/cards/build-your-course.jpg',
    ageRange: 'Age 5-17',
    gradeRange: 'Grade 1-12',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 'Flexible',
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: null,
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 2,
    title: 'Math lessons for 1st graders',
    description:
      'A joyful 81-lesson math adventure where children explore numbers through play, solve simple puzzles, discover shapes, measure their surroundings, and begin understanding the building blocks of math.',
    thumbnailLandscape: '/images/courses/math/cards/grade-1.jpg',
    ageRange: 'Age 5-7',
    gradeRange: 'Grade 1',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(1),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 3,
    title: 'Math lessons for 2nd graders',
    description:
      'A playful 81-lesson math journey where learners work with numbers, solve exciting problems, explore shapes, measure everyday objects, and start reading simple charts and patterns.',
    thumbnailLandscape: '/images/courses/math/cards/grade-2.jpg',
    ageRange: 'Age 6-8',
    gradeRange: 'Grade 2',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(2),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 4,
    title: 'Math lessons for 3rd graders',
    description:
      'A thoughtfully designed 81-lesson course where students build confidence in addition and subtraction, explore multiplication and division, understand fractions, and discover the world of geometry.',
    thumbnailLandscape: '/images/courses/math/cards/grade-3.jpg',
    ageRange: 'Age 7-9',
    gradeRange: 'Grade 3',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(3),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 5,
    title: 'Math lessons for 4th graders',
    description:
      'A comprehensive 81-lesson math experience where students strengthen number operations, work with fractions and decimals, explore geometry, measure real-world quantities, and analyse data.',
    thumbnailLandscape: '/images/courses/math/cards/grade-4.jpg',
    ageRange: 'Age 8-10',
    gradeRange: 'Grade 4',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(4),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 6,
    title: 'Math lessons for 5th graders',
    description:
      'A structured 81-lesson math journey where students deepen their understanding of numbers and operations, explore algebraic patterns, study geometry, measure precisely, and analyse data.',
    thumbnailLandscape: '/images/courses/math/cards/grade-5.jpg',
    ageRange: 'Age 9-11',
    gradeRange: 'Grade 5',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(5),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 7,
    title: 'Math lessons for 6th graders',
    description:
      'A concept-rich 72-lesson course where students explore the number system, understand ratios and proportional relationships, solve expressions and equations, and study geometry through Polypad and GeoGebra.',
    thumbnailLandscape: '/images/courses/math/cards/grade-6.jpg',
    ageRange: 'Age 10-12',
    gradeRange: 'Grade 6',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 72,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(6),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 8,
    title: 'Math lessons for 7th graders',
    description:
      'A progressive 81-lesson math program where students master ratios and proportions, strengthen number sense, work with expressions and equations, and apply geometry to real situations.',
    thumbnailLandscape: '/images/courses/math/cards/grade-7.jpg',
    ageRange: 'Age 11-13',
    gradeRange: 'Grade 7',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(7),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 9,
    title: 'Math lessons for 8th graders',
    description:
      'A well-sequenced 81-lesson math journey where students work with the number system, explore exponents and functions, study geometry, and apply statistics and probability.',
    thumbnailLandscape: '/images/courses/math/cards/grade-8.jpg',
    ageRange: 'Age 12-14',
    gradeRange: 'Grade 8',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: curriculumPdfFor(8),
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 10,
    title: 'Math lessons for 9th graders',
    description:
      'A rigorous math journey where students explore polynomials, solve equations and inequalities, work with coordinate geometry, study triangles and circles, and apply statistics and probability.',
    thumbnailLandscape: '/images/courses/math/cards/grade-9.jpg',
    ageRange: 'Age 13-15',
    gradeRange: 'Grade 9',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: null,
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 11,
    title: 'Math lessons for 10th graders',
    description:
      'An advanced math journey where students work with polynomials and real numbers, solve quadratic and radical equations, understand arithmetic progressions, and apply trigonometry and coordinate geometry.',
    thumbnailLandscape: '/images/courses/math/cards/grade-10.jpg',
    ageRange: 'Age 14-16',
    gradeRange: 'Grade 10',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: null,
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 12,
    title: 'Math lessons for 11th graders',
    description:
      'An advanced 72-lesson course where students master algebra, explore functions and trigonometry, work with sequences and the binomial theorem, and take their first steps into calculus and probability.',
    thumbnailLandscape: '/images/courses/math/cards/grade-11.jpg',
    ageRange: 'Age 15-17',
    gradeRange: 'Grade 11',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 72,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: null,
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
  {
    id: 13,
    title: 'Math lessons for 12th graders',
    description:
      'A rigorous math journey where students master differentiation and integration, explore vectors and complex numbers, solve differential equations, study probability distributions, and prepare for university-level math.',
    thumbnailLandscape: '/images/courses/math/cards/grade-12.jpg',
    ageRange: 'Age 16-18',
    gradeRange: 'Grade 12',
    estimatedCompletionTime: '9-12 months',
    studentsEnrolledCount: 1000,
    totalLessonsCount: 81,
    tags: null,
    landingPageUrl: null,
    paymentPageUrl: null,
    curriculumPdf: null,
    introVideoUrl: null,
    trialCourseSlug: TRIAL_SLUG,
  },
]
